import React, { useState } from 'react';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';
import slika6 from '../assets/slika6.jpg';
import slika7 from '../assets/slika7.jpeg';
import slika8 from '../assets/slika8.jpeg';

// Svi podaci o stanovima
const stanoviData = [
  {
    id: 1,
    title: 'Novi Sad, Bulevar Evrope 20',
    location: 'Novi Sad, Bulevar Evrope 20',
    price: 270,
    area: 23,
    rooms: 0.5,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika1, slika2, slika3],
    sifra: 'A50-1478',
    kupatila: 1,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Namešten',
    drzava: 'Srbija',     // Dodajemo državu
    grad: 'Novi Sad',     // Dodajemo grad
    transakcija: 'Izdavanje', // Tip transakcije
  },
  {
    id: 2,
    title: 'Novi Sad, Novo Naselje 30',
    location: 'Novi Sad, Novo Naselje 30',
    price: 450,
    area: 40,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika5, slika6, slika4],
    sifra: 'A50-1480',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  {
    id: 3,
    title: 'Beograd, Zemun 15',
    location: 'Beograd, Zemun 15',
    price: 680,
    area: 60,
    rooms: 2,
    type: 'Stan',
    date: '19/08/24',
    images: [slika7, slika8, slika3],
    sifra: 'A50-1490',
    kupatila: 2,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Prazan',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Izdavanje',
  },
  {
    id: 4,
    title: 'Novi Sad, Liman 2',
    location: 'Novi Sad, Liman 2',
    price: 320,
    area: 30,
    rooms: 1,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika2, slika5, slika4],
    sifra: 'A50-1500',
    kupatila: 1,
    parking: false,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 5,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Izdavanje',
  },
  {
    id: 5,
    title: 'Novi Sad, Grbavica 45',
    location: 'Novi Sad, Grbavica 45',
    price: 590,
    area: 45,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika3, slika8, slika1],
    sifra: 'A50-1505',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  {
    id: 6,
    title: 'Niš, Centar 8',
    location: 'Niš, Centar 8',
    price: 420,
    area: 40,
    rooms: 1,
    type: 'Stan',
    date: '19/08/24',
    images: [slika6, slika4, slika5],
    sifra: 'A50-1600',
    kupatila: 1,
    parking: false,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 3,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Niš',
    transakcija: 'Izdavanje',
  },
  {
    id: 7,
    title: 'Kragujevac, Stanovi 3',
    location: 'Kragujevac, Stanovi 3',
    price: 750,
    area: 75,
    rooms: 3,
    type: 'Stan',
    date: '19/08/24',
    images: [slika8, slika7, slika6],
    sifra: 'A50-1650',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Kragujevac',
    transakcija: 'Prodaja',
  },  {id: 8,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 270,
  area: 23,
  rooms: 0.5,
  type: 'Garsonjera',
  date: '19/08/24',
  images: [slika1, slika2, slika3],
  sifra: 'A50-1478',
  kupatila: 1,
  parking: true,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 1,
  namestenost: 'Namešten',
  drzava: 'Srbija',     // Dodajemo državu
  grad: 'Novi Sad',     // Dodajemo grad
  transakcija: 'Izdavanje', // Tip transakcije
},
{
  id: 9,
  title: 'Novi Sad, Novo Naselje 30',
  location: 'Novi Sad, Novo Naselje 30',
  price: 450,
  area: 40,
  rooms: 1.5,
  type: 'Stan',
  date: '19/08/24',
  images: [slika5, slika6, slika4],
  sifra: 'A50-1480',
  kupatila: 1,
  parking: true,
  namena: 'Prodaja',
  garaza: 'Da',
  spratovi: 2,
  namestenost: 'Polunamešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Prodaja',
},
{
  id: 10,
  title: 'Beograd, Zemun 15',
  location: 'Beograd, Zemun 15',
  price: 680,
  area: 60,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  images: [slika7, slika8, slika3],
  sifra: 'A50-1490',
  kupatila: 2,
  parking: true,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 1,
  namestenost: 'Prazan',
  drzava: 'Srbija',
  grad: 'Beograd',
  transakcija: 'Izdavanje',
},
{
  id: 11,
  title: 'Novi Sad, Liman 2',
  location: 'Novi Sad, Liman 2',
  price: 320,
  area: 30,
  rooms: 1,
  type: 'Garsonjera',
  date: '19/08/24',
  images: [slika2, slika5, slika4],
  sifra: 'A50-1500',
  kupatila: 1,
  parking: false,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 5,
  namestenost: 'Polunamešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Izdavanje',
},
{
  id: 12,
  title: 'Novi Sad, Grbavica 45',
  location: 'Novi Sad, Grbavica 45',
  price: 590,
  area: 45,
  rooms: 1.5,
  type: 'Stan',
  date: '19/08/24',
  images: [slika3, slika8, slika1],
  sifra: 'A50-1505',
  kupatila: 1,
  parking: true,
  namena: 'Prodaja',
  garaza: 'Da',
  spratovi: 2,
  namestenost: 'Namešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Prodaja',
}, {
  id: 13,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},
{
  id: 14,
  title: 'Novi Sad, Novo Naselje 30',
  location: 'Novi Sad, Novo Naselje 30',
  price: 150000,
  area: 60,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-5678',
  kupatila: 2,
  garaza: 'Ne',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika5, slika6, slika4],
},
{
  id: 15,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 16,
  title: 'Novi Sad, Novo Naselje 40',
  location: 'Novi Sad, Novo Naselje 40',
  price: 140000,
  area: 55,
  rooms: 2.5,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-7890',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Namešten',
  parking: 'Da',
  images: [slika7, slika8, slika2],
},
{
  id: 17,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 18,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
{
  id: 19,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},{
  id: 20,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 21,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
{
  id: 22,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},{
  id: 23,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 24,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
];



// Svi podaci o stanovima (stanoviData ostaje isti)



const MeniStan = ({ onFilter }) => {
  const [priceMin, setPriceMin] = useState('');
  const [priceMax, setPriceMax] = useState('');
  const [areaMin, setAreaMin] = useState('');
  const [areaMax, setAreaMax] = useState('');
  const [transactionType, setTransactionType] = useState('Prodaja');
  const [propertyType, setPropertyType] = useState('Stan');
  const [city, setCity] = useState('Novi Sad'); // Dodata opcija za biranje grada

  const handleSearch = () => {
    const filteredListings = stanoviData.filter((listing) => {
      const matchesPrice =
        (!priceMin || listing.price >= parseFloat(priceMin)) &&
        (!priceMax || listing.price <= parseFloat(priceMax));
      const matchesArea =
        (!areaMin || listing.area >= parseFloat(areaMin)) &&
        (!areaMax || listing.area <= parseFloat(areaMax));
      const matchesTransactionType = listing.transakcija === transactionType;
      const matchesPropertyType = listing.type === propertyType;
      const matchesCity = listing.grad === city; // Provera da li oglas odgovara gradu

      return matchesPrice && matchesArea && matchesTransactionType && matchesPropertyType && matchesCity;
    });

    onFilter(filteredListings); // Prosleđivanje rezultata u App.js
  };

  const handleInputChange = (e, setValue) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) { // Provera da li je validan broj ili prazna vrednost
      setValue(value);
    }
  };

  return (
    <div
      className="bg-gray-800 p-6 rounded-lg shadow-lg w-full border-2 border-pink-600"
      style={{ boxShadow: '0 0 20px 4px rgba(225, 0, 85, 0.8)' }} // Dodan isijavajući border
    >
      {/* Tip transakcije */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Tip transakcije</label>
        <select
          value={transactionType}
          onChange={(e) => setTransactionType(e.target.value)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
        >
          <option value="Prodaja">Prodaja</option>
          <option value="Izdavanje">Izdavanje</option>
        </select>
      </div>

      {/* Tip nekretnine */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Tip nekretnine</label>
        <select
          value={propertyType}
          onChange={(e) => setPropertyType(e.target.value)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
        >
          <option value="Stan">Stan</option>
          <option value="Kuća">Kuća</option>
          <option value="Garsonjera">Garsonjera</option>
        </select>
      </div>

      {/* Grad */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Grad</label>
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
        >
          <option value="Novi Sad">Novi Sad</option>
          <option value="Beograd">Beograd</option>
          <option value="Niš">Niš</option>
          <option value="Kragujevac">Kragujevac</option>
        </select>
      </div>

      {/* Cena od */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Cena od (€)</label>
        <input
          type="text"
          value={priceMin}
          onChange={(e) => handleInputChange(e, setPriceMin)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
          placeholder="Cena od"
        />
      </div>

      {/* Cena do */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Cena do (€)</label>
        <input
          type="text"
          value={priceMax}
          onChange={(e) => handleInputChange(e, setPriceMax)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
          placeholder="Cena do"
        />
      </div>

      {/* Kvadratura od */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Kvadratura od (m²)</label>
        <input
          type="text"
          value={areaMin}
          onChange={(e) => handleInputChange(e, setAreaMin)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
          placeholder="Kvadratura od"
        />
      </div>

      {/* Kvadratura do */}
      <div className="mb-4">
        <label className="block text-white text-sm mb-2">Kvadratura do (m²)</label>
        <input
          type="text"
          value={areaMax}
          onChange={(e) => handleInputChange(e, setAreaMax)}
          className="w-full p-2 border-2 border-pink-600 rounded bg-gray-700 text-white"
          placeholder="Kvadratura do"
        />
      </div>

      {/* Dugme za pretragu */}
      <div className="mt-6 text-left">
        <button
          onClick={handleSearch}
          className="bg-pink-700 text-white py-2 px-4 rounded-lg hover:bg-pink-600"
        >
          PRETRAGA
        </button>
      </div>
    </div>
  );
};

export default MeniStan;
